// Product Details Image Slider
import Swiper from "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs";

(() => {
  if (!customElements.get("product-details-images")) {
    class ProductDetailsImages extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
      }

      connectedCallback() {
        this.prevButton = this.querySelector(".product-details-images__slider-nav--prev");
        this.nextButton = this.querySelector(".product-details-images__slider-nav--next");

        requestAnimationFrame(() => {
          this.initSwiper();
        });
      }

      initSwiper() {
        const swiperEl = this.querySelector(".swiper");
        if (!swiperEl) {
          console.warn("Swiper element not found");
          return;
        }

        const swiperWrapper = swiperEl.querySelector(".swiper-wrapper");
        if (!swiperWrapper) {
          console.warn("Swiper wrapper not found");
          return;
        }

        const slides = swiperWrapper.querySelectorAll(".swiper-slide");
        if (slides.length === 0) {
          console.warn("No slides found");
          return;
        }

        let autoplay = false;
        let autoplayAttribute = this.attributes.getNamedItem("data-autoplay");
        if ((autoplayAttribute !== null) && (autoplayAttribute.value == "true")) {
          autoplay = {
            delay: Math.max(500, parseInt(this.attributes.getNamedItem("data-delay").value)),
            pauseOnMouseEnter: this.attributes.getNamedItem("data-pause").value == "true"
          };
        }
        let loop = false;
        let loopAttribute = this.attributes.getNamedItem("data-loop");
        if ((loopAttribute !== null) && (loopAttribute.value == "true")) {
          loop = true;
        }

        this.swiper = new Swiper(swiperEl, {
          slidesPerView: 1.5,
          spaceBetween: 4,
          speed: 300,
          loop: loop,
          autoplay: autoplay,
          grabCursor: true,
          observer: true,
          observeParents: true,
          navigation: {
            nextEl: this.nextButton,
            prevEl: this.prevButton,
          },
          breakpoints: {
            768: {
              slidesPerView: 2.5,
            },
            1600: {
              slidesPerView: 4,
              loop: false,
              autoplay: false,
            },
          },
        });
        if (Shopify.designMode) {
          this.addEventListener('shopify:block:select', (event) => {
            let slideEl = event.target.closest("swiper-slide") || event.target;
            let targetIndex = [...slides].indexOf(slideEl);
            if (targetIndex >= 0) {
              this.swiper.slideTo(targetIndex);
            }
          });
        }
      }

      reInit() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.initSwiper();
        }
      }

      disconnectedCallback() {
        this.swiper?.destroy(true, true);
      }
    }

    customElements.define("product-details-images", ProductDetailsImages);
  }
})();
